import React from "react";

const Footer = () => {
  return (
    <div className="bg-[#2699fb] w-full h-[50px] grid items-center">
      <h1 className="text-center  mg:text-2xl">
        Design & Developed by IHTESHAM UL HAQ 2023
      </h1>
    </div>
  );
};

export default Footer;
